import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import './scss/global.scss';
import { App } from 'app';

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root')
);
